import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';
import RequiresOnboardingComplete from '@/router/middleware/RequiresOnboardingComplete.tsx';
import OnboardingGate from '@/router/middleware/OnboardingGate.tsx';
import IsAdmin from '@/router/middleware/IsAdmin.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
    requiresOnboardingComplete: <RequiresOnboardingComplete />,
    onboardingGate: <OnboardingGate />,
    isAdmin: <IsAdmin />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
